module.exports = __webpack_public_path__ + "img/finished_white.00163473.svg";